import React, { useEffect, useState } from "react";
import "./PaginaPlanos.css";

import Footer from "../../components/footer/Footer";
import PainelLoader from "./PainelLoader";
import ModalPixCheckout from "./componentes/ModalPixCheckout";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCircleInfo,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const API_BASE = process.env.REACT_APP_API_BASE;

// ==========================================================
// PACOTES DE MOEDA
// ==========================================================
const PACOTES = [
  {
    id: "100",
    moedas: 100,
    preco: "6,00",
    precoLinear: null,
    desconto: null,
    destaque: false,
  },
  {
    id: "250",
    moedas: 250,
    preco: "13,90",
    precoLinear: "15,00",
    desconto: "7%",
    destaque: false,
  },
  {
    id: "500",
    moedas: 500,
    preco: "26,90",
    precoLinear: "30,00",
    desconto: "10%",
    destaque: true,
  },
  {
    id: "1000",
    moedas: 1000,
    preco: "47,90",
    precoLinear: "60,00",
    desconto: "20%",
    destaque: false,
  },
];

const PaginaPlanos = () => {
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  const [nome, setNome] = useState("");
  const [saldoMoedas, setSaldoMoedas] = useState(0);

  // 🆕 controla qual pacote está com o modal de Pix aberto
  const [pacoteSelecionado, setPacoteSelecionado] = useState(null);

  const [extrato, setExtrato] = useState([]);
  const [carregandoExtrato, setCarregandoExtrato] = useState(true);

  const carregarDados = async () => {
    setCarregando(true);
    setErro(null);

    try {
      const res = await fetch(`${API_BASE}/painel-dados.php`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status !== "sucesso") {
        throw new Error("Erro ao carregar dados.");
      }

      setNome(data.nome || "");
      setSaldoMoedas(data.saldo_moedas ?? 0);
    } catch (e) {
      console.error(e);
      setErro("Erro ao carregar informações do seu saldo.");
    } finally {
      setCarregando(false);
    }
  };

  const carregarExtratoResumo = async () => {
    setCarregandoExtrato(true);

    try {
      const res = await fetch(`${API_BASE}/extrato-moedas.php?limite=5`, {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "sucesso") {
        setExtrato(Array.isArray(data.transacoes) ? data.transacoes : []);
      }
    } catch {}

    setCarregandoExtrato(false);
  };

  useEffect(() => {
    carregarDados();
    carregarExtratoResumo();
  }, []);

  // 🆕 abre o modal de Pix pro pacote clicado
  const comprarPacote = (pacote) => {
    setPacoteSelecionado(pacote);
  };

  // 🆕 fecha o modal (com ou sem pagamento confirmado)
  const fecharModalPix = () => {
    setPacoteSelecionado(null);
  };

  // 🆕 chamado pelo ModalPixCheckout quando o pagamento é confirmado
  const handlePagamentoConfirmado = (moedasCreditadas) => {
    setSaldoMoedas((prev) => prev + moedasCreditadas);
    carregarExtratoResumo(); // atualiza o resumo com a nova transação

    // avisa o chip do topo (ProtectedLayout) que o saldo mudou
    window.dispatchEvent(new Event("saldo-moedas-atualizado"));
  };

  const formatarDataExtrato = (isoStr) => {
    if (!isoStr) return "";
    const data = new Date(isoStr.replace(" ", "T"));
    const agora = new Date();
    const diffMs = agora - data;
    const diffHoras = diffMs / (1000 * 60 * 60);

    if (diffHoras < 24 && data.getDate() === agora.getDate()) {
      const horas = Math.floor(diffHoras);
      if (horas < 1) return "agora há pouco";
      return `há ${horas}h`;
    }

    const ontem = new Date(agora);
    ontem.setDate(agora.getDate() - 1);
    if (data.getDate() === ontem.getDate() && data.getMonth() === ontem.getMonth()) {
      return "ontem";
    }

    return data.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
  };

  if (carregando) return <PainelLoader />;

  return (
    <div className="painel-container pagina-planos-container">

      <button
        className="btn-voltar"
        onClick={() => (window.location.href = "/painel")}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Voltar ao painel
      </button>

      <img src="/assets/logo2.png" alt="Logo" className="painel-logo" />

      <div className="pagina-planos-header">
        <h2>Recarregar moedas</h2>
        <p>
          Olá{nome ? `, ${nome}` : ""}! Compre moedas e use quando quiser — sem mensalidade.
        </p>
      </div>

      <div className="pagina-planos-aviso">
        <FontAwesomeIcon icon={faCircleInfo} />
        Pagamento único via Pix. <strong>Suas moedas nunca expiram.</strong>
      </div>

      {erro && (
        <div className="pagina-planos-alerta-erro">
          <FontAwesomeIcon icon={faCircleInfo} /> {erro}
        </div>
      )}

      <section className="saldo-atual-section">
        <div className="saldo-atual-card">
          <img src="/moeda.png" alt="Moedas" className="saldo-atual-icone" />
          <div className="saldo-atual-textos">
            <span className="saldo-atual-label">Seu saldo atual</span>
            <strong className="saldo-atual-valor">{saldoMoedas}</strong>
          </div>
          <a href="/extrato" className="saldo-atual-btn-extrato">
            Ver extrato
          </a>
        </div>
      </section>

      <section className="pacotes-section">
        <h3 className="subtitulo">Escolha um pacote</h3>

        <div className="pacotes-grid">
          {PACOTES.map((pacote) => (
            <div
              key={pacote.id}
              className={`pacote-card ${pacote.destaque ? "pacote-destaque" : ""}`}
            >
              {pacote.destaque && (
                <span className="pacote-badge">Mais popular</span>
              )}

              <div className="pacote-moeda-visual">
                <img src="/moeda.png" alt="Moedas" className="pacote-moeda-icone" />
                <span className="pacote-moeda-quantidade">{pacote.moedas}</span>
              </div>

              <div className="pacote-preco-linha">
                {pacote.precoLinear && (
                  <span className="pacote-preco-linear">R$ {pacote.precoLinear}</span>
                )}
                <span className="pacote-preco">R$ {pacote.preco}</span>
              </div>

              {pacote.desconto && (
                <span className="pacote-desconto-tag">-{pacote.desconto}</span>
              )}

              <button
                className="pacote-botao-comprar"
                onClick={() => comprarPacote(pacote)}
              >
                Comprar
              </button>
            </div>
          ))}
        </div>
      </section>

      <section className="extrato-resumo-section">
        <h3 className="subtitulo">Últimos registros</h3>

        {carregandoExtrato && (
          <p className="extrato-resumo-carregando">Carregando...</p>
        )}

        {!carregandoExtrato && extrato.length === 0 && (
          <p className="extrato-resumo-vazio">Nenhuma movimentação ainda.</p>
        )}

        {!carregandoExtrato && extrato.length > 0 && (
          <div className="extrato-resumo-lista">
            {extrato.map((t) => (
              <div key={t.id} className="extrato-resumo-item">
                <img src="/moeda.png" alt="Moeda" className="extrato-resumo-icone" />
                <div className="extrato-resumo-info">
                  <span className="extrato-resumo-motivo">{t.motivo}</span>
                  <span className="extrato-resumo-data">
                    {formatarDataExtrato(t.data)}
                  </span>
                </div>
                <span
                  className={`extrato-resumo-valor ${
                    t.quantidade < 0 ? "negativo" : "positivo"
                  }`}
                >
                  {t.quantidade > 0 ? "+" : ""}
                  {t.quantidade}
                </span>
              </div>
            ))}
          </div>
        )}

        <a href="/extrato" className="extrato-resumo-link">
          Ver extrato completo <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </section>

      <section className="como-funciona-section">
        <h3 className="subtitulo">Como funciona</h3>
        <ul className="como-funciona-lista">
          <li>Você tem <strong>3 cálculos grátis por dia</strong>, sempre.</li>
          <li>Depois disso, cada cálculo novo custa <strong>2 moedas</strong>.</li>
          <li>Sugestões e favoritos continuam <strong>grátis</strong>, a menos que você edite algo.</li>
          <li>Enquanto tiver saldo, os anúncios ficam desativados.</li>
        </ul>
      </section>

      {/* 🆕 MODAL DE CHECKOUT PIX */}
      {pacoteSelecionado && (
        <ModalPixCheckout
          pacote={pacoteSelecionado}
          onClose={fecharModalPix}
          onPagamentoConfirmado={handlePagamentoConfirmado}
        />
      )}

      <Footer />
    </div>
  );
};

export default PaginaPlanos;